import * as convoSvc from 'services/conversations.service';
import * as groupSvc from 'services/groups.service';
import { resolved } from 'store/createAction';
import {
  ARCHIVE_ALL_CONVERSATIONS,
  ARCHIVE_CONVERSATIONS,
  CREATE_INBOX,
  DELETE_MESSAGE,
  GET_ARCHIVED_CONVERSATIONS,
  GET_CONVERSATIONS,
  GET_INBOXES,
  GET_MESSAGES,
  GET_NEW_MESSAGE_COUNT,
  GET_PENDING_GROUP_MESSAGES,
  GET_PENDING_MESSAGES,
  GET_SENT_GROUP_MESSAGES,
  GET_SENT_MESSAGES,
  SEND_REPLY_MESSAGE,
  SET_ACTIVE_INBOX,
  UPDATE_CONVERSATIONS,
  UPDATE_MESSAGE,
} from './types';

export const getInboxes = () => ({
  type: GET_INBOXES,
  payload: {
    promise: convoSvc.getInboxes(),
  },
});

export const getConversations = (query, reset) => ({
  type: GET_CONVERSATIONS,
  payload: {
    promise: convoSvc.getInboxItems(query),
    query,
    reset,
  },
});

export const getArchivedConversations = (query, reset) => ({
  type: GET_ARCHIVED_CONVERSATIONS,
  payload: {
    promise: convoSvc.getInboxItems({
      ...query,
      inbox_item_archived: 1,
    }),
    query,
    reset,
  },
});

export const updateThread = (contactHash, update) => ({
  type: UPDATE_CONVERSATIONS,
  payload: {
    promise: convoSvc.updateInboxItem(null, update),
    convoId: contactHash,
  },
});

export const updateMultiConversations = (ids, payload) => ({
  type: UPDATE_CONVERSATIONS,
  payload: {
    promise: convoSvc.updateInboxItem(ids, payload),
  },
});

export const getMessages = (convoId, query = {}) => ({
  type: GET_MESSAGES,
  payload: {
    promise: convoSvc.contactActions(convoId, {
      ...query,
    }),
    convoId,
    inboxId: query.inbox_id,
    offset: query.offset,
    limit: query.limit,
  },
});

export const getPendingMessages = (query, reset) => ({
  type: GET_PENDING_MESSAGES,
  payload: {
    promise: convoSvc.getPendingMessages(query),
    query,
    reset,
  },
});

export const archiveConversations = (ids, status) => ({
  type: ARCHIVE_CONVERSATIONS,
  payload: {
    promise: convoSvc.updateInboxItem(null, {
      hash: ids,
      inbox_item_archived: status,
    }),
    status,
  },
});

export const archiveThread = (contactHash, status) => ({
  type: ARCHIVE_CONVERSATIONS,
  payload: {
    promise: convoSvc.updateInboxItem(null, {
      contact_hash: contactHash,
      inbox_item_archived: status,
    }),
    status,
  },
});

export const archiveAllConversations = (status) => ({
  type: ARCHIVE_ALL_CONVERSATIONS,
  payload: {
    promise: convoSvc.setArchiveAllConversations(status),
    status,
  },
});

export const deleteMessage = (id) => ({
  type: DELETE_MESSAGE,
  payload: {
    promise: convoSvc.deleteMessage(id),
    id,
  },
});

export const updateMessage = () => ({
  type: UPDATE_MESSAGE,
});

export const getSentMessages = (query, reset) => ({
  type: GET_SENT_MESSAGES,
  payload: {
    promise: convoSvc.getSentMessages(query),
    query,
    reset,
  },
});

export const getNewMessagesCount = () => ({
  type: GET_NEW_MESSAGE_COUNT,
  payload: {
    promise: convoSvc.getNewMessagesCount(),
  },
});

export const addConvoMessage = (key, message) => ({
  type: resolved(SEND_REPLY_MESSAGE),
  payload: message,
  meta: {
    key,
  },
});

export const getPendingGroupMessages = (query) => ({
  type: GET_PENDING_GROUP_MESSAGES,
  payload: {
    promise: groupSvc.getGroupMessages({ ...query, msg_sent: 0 }),
  },
});

export const getSentGroupMessages = (query) => ({
  type: GET_SENT_GROUP_MESSAGES,
  payload: {
    promise: groupSvc.getGroupMessages({
      ...query,
      msg_sent: 1,
    }),
  },
});

export const setActiveInbox = (id) => ({
  type: SET_ACTIVE_INBOX,
  payload: id,
});
